export default __webpack_public_path__ + "static/face-to-face-54aaa00f533453e7d991dbd50dc3a810.mp4";